import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import DataTable from '../DataTable';
import Spinner from "../Spinner";
import { toJS } from 'mobx';
import HierTable from '../HierTable';

@observer
class ItemList extends React.Component {
  static propTypes = {
    params: PropTypes.shape(),
    route: PropTypes.shape(),
    children: PropTypes.node,
    slug: PropTypes.string.isRequired,
    columns: PropTypes.array.isRequired,
    actions: PropTypes.array,
    onDelete: PropTypes.func,
    onSelect: PropTypes.func,
    allowAdd: PropTypes.bool,
    allowEdit: PropTypes.bool,
    allowDelete: PropTypes.bool
  }

  static contextTypes = {
    notify: PropTypes.object.isRequired,
  };


  componentWillMount() {
    const { store } = this.props;
    if (!store.isLoading && !store.isEmpty && !store.items.length) store.fetchItems();
  }

  handleDelete = (idOrIds) => {
    const { store } = this.props;
    const { notify } = this.context;

    store.removeItems(idOrIds)
      .then(() => {
        notify.success({ message: 'Deleted' });
      })
      .catch((err) => {
        notify.error(err);
      });
  }


  render() {
    const { store, children, resources, columns, slug, allowAdd, allowDelete, allowEdit, onSelect, data, hierTable, actions, resource } = this.props;
    if (store.isLoading && !children) return <Spinner />

    return (
      <div>
        {!!hierTable ? (
          <div>
            <HierTable
              slug={slug}
              data={data}
              columns={columns}
              onDelete={this.handleDelete}
              allowAdd={allowAdd}
              allowEdit={allowEdit}
              allowDelete={allowDelete}
              resources={resources}
              actions={actions}
            />
            {children}
          </div>
        ) : (
          <div>
            <DataTable
              data={data || toJS(store.items)}
              slug={slug}
              columns={columns}
              onDelete={this.handleDelete}
              allowAdd={allowAdd}
              allowEdit={allowEdit}
              allowDelete={allowDelete}
              resource={resource}
              onSelect={onSelect}
            />
            {children}
          </div>
        )}
      </div>
    );
  }

}




export default ItemList;


// WEBPACK FOOTER //
// ./src/components/Form/ItemList.js